/**
 * A decorator for mocking purposes
 *
 * nodejs libs don't include Intl out of the box
 * and may cause testing environments to fail due missing dependencies
 */
export function createIntlDisplayNames(
  locals = ["en"],
  options = { type: "region" }
) {
  return new Intl.DisplayNames(locals, options);
}

export default createIntlDisplayNames;
